import React from 'react'
import {
  getBlurbWordCount,
  MAX_BLURB_TRANSLATION_WORDS,
} from '../utils/metadataFreeRuns'

interface BlurbWordCounterProps {
  value: unknown
  maxWords?: number
  className?: string
}

const BlurbWordCounter: React.FC<BlurbWordCounterProps> = ({
  value,
  maxWords = MAX_BLURB_TRANSLATION_WORDS,
  className = '',
}) => {
  const wordCount = getBlurbWordCount(value)
  const isOverLimit = wordCount > maxWords
  const remaining = maxWords - wordCount

  return (
    <div
      className={['blurb-word-counter', isOverLimit ? 'blurb-word-counter--over' : '', className].filter(Boolean).join(' ')}
      aria-live="polite"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 12,
        marginTop: 6,
        fontSize: 12,
        color: isOverLimit ? 'var(--text-danger)' : 'var(--text-secondary)',
      }}
    >
      <span>
        {wordCount.toLocaleString()} / {maxWords.toLocaleString()} words
      </span>
      <span>
        {isOverLimit
          ? `Shorten by ${Math.abs(remaining).toLocaleString()} words`
          : `${remaining.toLocaleString()} words remaining`}
      </span>
    </div>
  )
}

export default BlurbWordCounter
